export const IconCandidateSearch: {
  name: 'icon_candidate_search-b93be67ec495'
} = {
  name: 'icon_candidate_search-b93be67ec495'
}
